import * as React from 'react'

function SvgKw(props) {
	return (
		<svg viewBox="0 0 12 6" width="1em" height="1em" {...props}>
			<path fill="#007a3d" d="M0 0h12v2H0z" />
			<path fill="#fff" d="M0 2h12v2H0z" />
			<path fill="#ce1126" d="M0 4h12v2H0z" />
			<path d="M0 0l3 2v2L0 6z" />
		</svg>
	)
}

export default SvgKw
